import { IconButtonToggle } from '@llt-frontend/react-material-button';
import { LIST_TYPES } from '@llt-frontend/react-material-list';
import React from 'react';
import getSubjectNavigationItemList from './get-subject-item-list';

//

function getSubjectNavigationSection({
  addSubjectLink,
  addSubjectText,
  actions,
  deletedSubjectIds,
  editToggleLabel,
  editMode,
  errorLoadingText,
  failedToLoadSubjects,
  handleDeletedSubject,
  handleDeletingSubject,
  handleEditModeToggle,
  handleFailedToDeleteSubject,
  heading,
  loadingText,
  navRoot,
  subjects,
  subjectType,
  subjectsLoading,
}) {
  return {
    'data-testid': `${subjectType}-nav-section`,
    'aria-label': `${subjectType} navigation`,
    heading,
    headingControl:
      actions.includes('edit') && subjects && subjects.length ? (
        <IconButtonToggle
          className="side-navigation__edit-button"
          data-testid={`edit-${subjectType}-subjects`}
          label={editToggleLabel}
          on={editMode}
          onClick={handleEditModeToggle}
        >
          {['close', 'edit']}
        </IconButtonToggle>
      ) : undefined,
    items: getSubjectNavigationItemList({
      addSubjectLink,
      addSubjectText,
      actions,
      editMode,
      errorLoadingText,
      failedToLoadSubjects,
      handleDeletedSubject,
      handleDeletingSubject,
      handleFailedToDeleteSubject,
      loadingText,
      navRoot,
      subjectType,
      subjectsLoading,
      subjects:
        subjects &&
        subjects.filter(function _filterOutDeletedSubjects({ id }) {
          return !deletedSubjectIds.includes(id);
        }),
    }),
    listType: LIST_TYPES.navigation,
    withDivider: true,
  };
}

// Exports
// -------

export default getSubjectNavigationSection;
